//import thu vien react
import { useContext } from "react";
import { Link } from "react-router-dom";

//import để sử dụng phần state toàn cục
import Context from '../../Store/Context';

//import thư viện chung
import {formatCurrency} from '../../Common/FormatCurrency';
import {formatNumber} from "../../Common/FormatNumber";
import {colorValue} from "../../Common/FunctionPerValue"

//import component
import LineChar from "../Chart/LineChart";


function CoinTableItemCpn({dataItem,dataIndex}){

    //phần state toàn cục
    const [state,dispatch] = useContext(Context);
    const {currency} = state;

    const {id,name,symbol,current_price,price_change_percentage_1h_in_currency,price_change_percentage_24h_in_currency,price_change_percentage_7d_in_currency,
      market_cap,total_volume,image,fully_diluted_valuation,sparkline_in_7d
    } = dataItem;



    // let marketCap_fdv = 0;
    // if(fully_diluted_valuation!== null && fully_diluted_valuation>0){
    //   marketCap_fdv = market_cap/fully_diluted_valuation;
    //   marketCap_fdv = formatNumber(marketCap_fdv,2);
    // }

    //hiển thị màu biểu đồ
    //nếu giá trị âm thì hiển thị màu đỏ
    //ngược lại thì hiển thị màu xanh lá
    const colorChart = () =>{
      let color = "#007f3f";
      if(formatNumber(price_change_percentage_1h_in_currency)+formatNumber(price_change_percentage_7d_in_currency)
        +formatNumber(price_change_percentage_24h_in_currency)<0)
         color = "rgb(220, 53, 69)";

      return color;
    }

    return (
        <>
        <tr>
          <td>
            <div>{dataIndex+1}</div>
          </td>
          <td style={{textAlign:"left"}}>
            <div className="d-flex align-items-center fw-medium">
              {/* <Link to={`/crypto/coin/${id}`}> */}
              <Link to={`https://www.coingecko.com/vi/ty_gia/${id}`} target="_blank">
              <img
                className="basic_top_avatar me-2"
                src={image} alt="logo"
                style={{ width: "1.5rem" }}
              ></img></Link>  <Link to={`https://www.coingecko.com/vi/ty_gia/${id}`} target="_blank"><span className="nameTable" style={{color:"var(--color-primary)"}}>{name}</span> <span style={{textTransform:"uppercase",color:"rgb(100 116 139"}}>({symbol})</span></Link>
            </div>
          </td>

          <td>
            <div>{formatCurrency(current_price,currency)}</div>
          </td>
          <td>
            {colorValue(price_change_percentage_1h_in_currency)}
          </td>
          <td>
            {colorValue(price_change_percentage_24h_in_currency)}
          </td>
          <td>
            {colorValue(price_change_percentage_7d_in_currency)}
          </td>
          <td>
            <div>
              <span>{formatCurrency(total_volume,currency)}</span>
            </div>
          </td>
          <td>
            <div>
              <span>{formatCurrency(market_cap,currency)}</span>
            </div>
          </td>
          {/* <td style={{textAlign:"center"}}>
            <div>
              <span>{marketCap_fdv}</span>
            </div>
          </td> */}
          <td>
             <div style={{width:"120px",height:"60px",margin:"auto"}}>
            
                {<LineChar dataItem={sparkline_in_7d.price} colorChart={colorChart()} />}
            
             </div>
          </td>
        </tr>
      </>
      
    )
}

export default CoinTableItemCpn;